var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.orgErrorMessage && _vm.orgErrorMessage !== '')?_c('div',{staticClass:"error-area",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isStickyWidth: _vm.isStickyWidth,
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isI18nId: _vm.$i18n.locale == 'id',
    isI18nMs: _vm.$i18n.locale == 'ms',
    isI18nTh: _vm.$i18n.locale == 'th',
    isI18nZh: _vm.$i18n.locale == 'zh'
  },attrs:{"data-testid":"org-error-message"},domProps:{"innerHTML":_vm._s(_vm.orgErrorMessage)},on:{"click":_vm.onClickErrorLink}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }